const hideFiltersCollection = ['root-touch-up'];
export default hideFiltersCollection;
